// extracted by mini-css-extract-plugin
export default {"card":"card_card__B1Hm1","menores":"card_menores__m6yzd","invertida":"card_invertida__7SqbC"};